<template>
    <v-card :loading="loading">
        <v-card-title class="text-h5">Register Production</v-card-title>
        <v-divider class="ml-4 mr-5" />
        <v-card-text>
            <v-form v-model="valid" class="mt-3 mx-1">
                <v-row no-gutters>
                    <v-col
                        cols="12"
                        xl="6"
                        lg="6"
                        md="6"
                        class="d-flex align-center"
                    >
                        <v-combobox
                            v-model="selectedProcess"
                            hide-details
                            label="Process*"
                            prepend-icon="mdi-tools"
                            :items="processes"
                            item-text="name"
                            :rules="[rules.required]"
                            required
                            class="pr-3"
                            @change="calculateValues"
                        />
                    </v-col>
                    <v-col
                        cols="12"
                        xl="6"
                        lg="6"
                        md="6"
                        class="d-flex align-center"
                    >
                        <v-combobox
                            v-model="selectedMachine"
                            hide-details
                            label="Machine*"
                            prepend-icon="mdi-cog"
                            :items="processMachines"
                            item-text="name"
                            :rules="[rules.required]"
                            required
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters class="pt-3">
                    <v-col
                        cols="12"
                        xl="6"
                        lg="6"
                        md="6"
                        class="d-flex align-center"
                    >
                        <div class="d-flex align-center">
                            <v-icon class="pr-2">mdi-database-outline</v-icon>
                            <p class="mb-0">
                                Available Quantity:
                                {{ Math.floor(+availableQty) }}
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" md="6">
                        <v-text-field
                            v-model="productionQty"
                            prepend-icon="mdi-database-plus-outline"
                            label="Produced Quantity*"
                            type="number"
                            min="0"
                            step="1"
                            required
                            :rules="[
                                rules.required,
                                rules.minValue,
                                maxValue(),
                            ]"
                            class="ma-0"
                            :max="availableQty"
                            @keypress="onlyInteger"
                        />
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions class="pb-3 pt-0">
            <v-btn text color="secondary" @click="close">
                Close
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                v-if="
                    workOrder.assemblyWorkOrder &&
                        item.processes[0] == selectedProcess.id
                "
                color="primary"
                :disabled="loading || !valid"
                @click="openComponentsDialog"
            >
                Get Components
            </v-btn>
            <v-btn
                v-else
                color="primary"
                :disabled="loading || !valid"
                @click="save"
            >
                Save
            </v-btn>
        </v-card-actions>
        <!-- Assembly Components Dialog -->
        <v-dialog v-model="openAssemblyComponentsDialog" max-width="1000px">
            <AssemblyComponents
                v-if="openAssemblyComponentsDialog"
                :productionInfo="productionInfo"
                :workOrder="workOrder"
                :selectedProcess="selectedProcess"
                @closeDialog="closeComponentsDialog"
                @closeAll="closeAll"
            />
        </v-dialog>
    </v-card>
</template>

<script>
import API from '@/services/api'
import { mapMutations } from 'vuex'
//import _ from 'lodash'
import AssemblyComponents from './AssemblyComponents.vue'
import _ from 'lodash'

export default {
    name: 'RegisterProduction',
    components: {
        AssemblyComponents,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        workOrder: {
            type: Object,
            required: true,
        },
        settings: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
    },

    data: () => ({
        valid: false,
        loading: false,
        selectedProcess: undefined,
        confirmCode: undefined,
        code: undefined,
        productionQty: undefined,
        machines: [],
        processMachines: [],
        selectedMachine: undefined,
        availableQty: 0,
        processes: [],
        rules: {
            required: v => !!v || 'The value is required',
            minValue: v => v > 0 || 'The value must be greater than 0',
        },
        packingProcess: { id: 'packing', name: 'Packing' },
        qualityProcess: { id: 'quality', name: 'Quality' },
        mappedProcesses: [],
        openAssemblyComponentsDialog: false,
        productionInfo: [],
    }),
    watch: {
        'item.production': {
            handler() {
                this.calculateValues()
            },
            deep: true,
        },
        'item.deliveries': {
            handler() {
                this.calculateValues()
            },
            deep: true,
        },
    },
    async mounted() {
        try {
            this.machines = this.settings.machines

            let userProcessIds = this.user.process.map(p => p.id)

            this.mappedProcesses = this.item.processes.map(processId => {
                if (processId == this.packingProcess.id) {
                    return this.packingProcess
                } else if (processId == this.qualityProcess.id) {
                    return this.qualityProcess
                } else {
                    return this.item.dataProcesses.find(p => p.id == processId)
                }
            })
            this.processes = this.mappedProcesses.filter(p =>
                userProcessIds.includes(p.id)
            )

            if (this.processes.length > 0) {
                this.selectedProcess = this.processes[0]

                this.processMachines = this.machines.filter(
                    machine => machine.process == this.selectedProcess.id
                )

                this.calculateValues()
            }
        } catch (error) {
            console.log(error)
        }
    },

    methods: {
        ...mapMutations(['setErrorItems']),
        close() {
            this.$emit('closeDialog')
        },
        calculateValues() {
            try {
                const processIndex = this.mappedProcesses.findIndex(
                    p => p.id == this.selectedProcess.id
                )
                if (processIndex > -1) {
                    let totalProduced = 0
                    let totalDelivered = 0

                    this.prevProcess = this.processes[processIndex - 1]
                    if (this.item.deliveries) {
                        let delivered = this.item.deliveries.filter(
                            register =>
                                register.nextProcess.id ==
                                this.selectedProcess.id
                        )
                        totalDelivered = delivered.reduce(
                            (total, register) =>
                                total +
                                (register.receivedBy ? register.qty : 0),
                            0
                        )
                    }
                    if (
                        processIndex == 0 &&
                        !this.workOrder.assemblyWorkOrder
                    ) {
                        totalDelivered += this.item.quantity
                    }

                    //TODO: Implement assembly items delivery calculation
                    if (processIndex == 0 && this.workOrder.assemblyWorkOrder) {
                        totalDelivered = this.item.quantity
                        // if (this.item.assemblyItems) {
                        //     this.item.assemblyItems.forEach(ai => {
                        //         let receivedQty = 0
                        //         if (ai.deliveries) {
                        //             receivedQty = ai.deliveries.reduce(
                        //                 (accumulator, delivery) =>
                        //                     accumulator + delivery.qty,
                        //                 0
                        //             )
                        //         }
                        //         const assemblyQty =
                        //             receivedQty / ai.qtyPerAssembly
                        //         if (assemblyQty < totalDelivered) {
                        //             totalDelivered = assemblyQty
                        //         }
                        //     })
                        // }
                    }

                    if (this.item.production) {
                        let produced = this.item.production.filter(
                            register =>
                                register.process.id == this.selectedProcess.id
                        )
                        totalProduced = produced.reduce(
                            (total, register) => total + register.qty,
                            0
                        )
                    }
                    this.availableQty = totalDelivered - totalProduced
                    this.processMachines = this.machines.filter(
                        machine => machine.process == this.selectedProcess.id
                    )
                }
            } catch (error) {
                console.error(error)
            }
        },
        async save() {
            try {
                this.loading = true
                // Limpiar el objeto machine para solo incluir id y name
                const machine = _.cloneDeep(this.selectedMachine)
                delete machine.process
                delete machine.description

                const items = await API.registerProduction({
                    partNumberId: this.item.partNumberId,
                    workOrderId: this.workOrder.id,
                    qty: this.productionQty,
                    process: this.selectedProcess,
                    machine,
                })
                this.$emit('closeDialog', items)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        matchCode() {
            return !!(
                this.code &&
                this.confirmCode &&
                this.code === this.confirmCode
            )
        },
        maxValue() {
            if (this.productionQty > this.availableQty) {
                return 'The value exceeds existences'
            }
            return true
        },
        onlyInteger(event) {
            // Prevent decimal point, comma, minus, plus, and e (exponential)
            const char = String.fromCharCode(event.keyCode || event.which)
            if (['.', ',', '-', '+', 'e', 'E'].includes(char)) {
                event.preventDefault()
            }
        },
        openComponentsDialog() {
            this.openAssemblyComponentsDialog = true
            this.productionInfo = [
                {
                    item: this.item,
                    productionQty: this.productionQty,
                    selectedMachine: this.selectedMachine,
                },
            ]
        },
        closeComponentsDialog() {
            this.openAssemblyComponentsDialog = false
        },
        closeAll(items) {
            this.openAssemblyComponentsDialog = false
            this.$emit('closeDialog', items)
        },
    },
}
</script>

<style>
#virtual-scroll-table {
    width: 100%;
    overflow: auto;
}
</style>
